import gql from 'graphql-tag';

import GraphQLClient, { GraphQLOperationFailed } from '../../adapter/GraphQLClient';
import TiktokAdAccount from '../../entity/TiktokAdAccount';
import TiktokUploadedCreative from '../../entity/TiktokUploadedCreative';

export const handleTiktokAdError = (err: GraphQLOperationFailed) => {
  switch (err.type) {
    case 'create_token-invalid_params':
      throw new CreateTokenInvalidParamsError();
    case 'create_token-get_access_token_failed':
      throw new CreateTokenGetAccessTokenFailedError();
    case 'create_token-no_related_ad_accounts':
      throw new CreateTokenNoRelatedAdAccountsError();
    case 'create_token-no_permission':
      throw new CreateTokenNoPermissionError();
    case 'create_token-get_user_info_failed':
      throw new CreateTokenGetUserInfoFailedError();
    case 'create_token-register_data_failed':
      throw new CreateTokenRegisterDataFailedError();
    case 'linked_list-invalid_params':
      throw new LinkedListInvalidParamsError();
    case 'linkable_list-invalid_params':
      throw new LinkableListInvalidParamsError();
    case 'linkable_list-create_tiktok_client_failed':
      throw new LinkableListCreateTiktokClientFailedError();
    case 'linkable_list-list_accounts_failed':
      throw new LinkableListListAccountsFailedError();
    case 'linkable_list-list_account_details_failed':
      throw new LinkableListListAccountDetailsFailedError();
    case 'uploaded_creatives-invalid_params':
      throw new UploadedCreativesInvalidParamsError();
    case 'upload_creative-invalid_params':
      throw new UploadCreativeInvalidParamsError();
    case 'upload_creative-token_not_found':
      throw new UploadCreativeTokenNotFoundError();
    case 'upload_creative-create_tiktok_client_failed':
      throw new UploadCreativeCreateTiktokClientFailedError();
    case 'upload_creative-create_tmp_file_failed':
      throw new UploadCreativeCreateTmpFileFailedError();
    case 'upload_creative-downloading_creative_failed':
      throw new UploadCreativeDownloadingCreativeFailedError();
    case 'upload_creative-copy_download_creative_failed':
      throw new UploadCreativeCopyDownloadCreativeFailedError();
    case 'upload_creative-register_data_failed':
      throw new UploadCreativeRegisterDataFailedError();
    case 'upload_creative-upload_file_failed':
      throw new UploadCreativeUploadFileFailedError();
    case 'upload_creative-upload_video_failed':
      throw new UploadCreativeUploadVideoFailedError();
    case 'upload_creative-get_video_info_failed':
      throw new UploadCreativeGetVideoInfoFailedError();
    case 'upload_creative-no_permission':
      throw new UploadCreativeNoPermissionError();
    case 'link_accounts-invalid_params':
      throw new LinkAccountsInvalidParamsError();
    case 'link_accounts-duplicate':
      throw new LinkAccountsDuplicateError();
    case 'link_accounts-register_token_adaccount_failed':
      throw new LinkAccountsRegisterTokenAdaccountFailedError();
    case 'link_accounts-token_not_found':
      throw new LinkAccountsTokenNotFoundError();
    case 'link_accounts-create_tiktok_client_failed':
      throw new LinkAccountsCreateTiktokClientFailedError();
    case 'link_accounts-get_account_api_failed':
      throw new LinkAccountsGetAccountApiFailedError();
    case 'link_accounts-register_adaccount_failed':
      throw new LinkAccountsRegisterAdaccountFailedError();
    case 'unlink_accounts-invalid_params':
      throw new UnlinkAccountsInvalidParamsError();
    case 'unlink_accounts-adaccount_not_found':
      throw new UnlinkAccountsAdaccountNotFoundError();
    case 'unlink_accounts-delete_adaccount_failed':
      throw new UnlinkAccountsDeleteAdaccountFailedError();
    case 'upload_creative-validation_error_duplicate':
      throw new UploadCreativeValidationErrorDuplicate();
    case 'upload_creative-validation_error_max_file_size':
      throw new UploadCreativeValidationErrorMaxFileSize();
    default:
      throw err;
  }
};
export class CreateTokenInvalidParamsError extends Error {
  public readonly name = 'CreateTokenInvalidParamsError';
  public readonly message = 'message.tiktok_create_token-invalid_params';
  constructor() {
    super();
  }
}
export class CreateTokenGetAccessTokenFailedError extends Error {
  public readonly name = 'CreateTokenGetAccessTokenFailedError';
  public readonly message = 'message.tiktok_create_token-get_access_token_failed';
  constructor() {
    super();
  }
}
export class CreateTokenNoRelatedAdAccountsError extends Error {
  public readonly name = 'CreateTokenNoRelatedAdAccountsError';
  public readonly message = 'message.tiktok_create_token-no_related_ad_accounts';
  constructor() {
    super();
  }
}
export class CreateTokenNoPermissionError extends Error {
  public readonly name = 'CreateTokenNoPermissionError';
  public readonly message = 'message.tiktok_create_token-no_permission';
  constructor() {
    super();
  }
}
export class CreateTokenGetUserInfoFailedError extends Error {
  public readonly name = 'CreateTokenGetUserInfoFailedError';
  public readonly message = 'message.tiktok_create_token-get_user_info_failed';
  constructor() {
    super();
  }
}
export class CreateTokenRegisterDataFailedError extends Error {
  public readonly name = 'CreateTokenRegisterDataFailedError';
  public readonly message = 'message.tiktok_create_token-register_data_failed';
  constructor() {
    super();
  }
}
export class LinkedListInvalidParamsError extends Error {
  public readonly name = 'LinkedListInvalidParamsError';
  public readonly message = 'message.tiktok_linked_list-invalid_params';
  constructor() {
    super();
  }
}
export class LinkableListInvalidParamsError extends Error {
  public readonly name = 'LinkableListInvalidParamsError';
  public readonly message = 'message.tiktok_linkable_list-invalid_params';
  constructor() {
    super();
  }
}
export class LinkableListCreateTiktokClientFailedError extends Error {
  public readonly name = 'LinkableListCreateTiktokClientFailedError';
  public readonly message = 'message.tiktok_linkable_list-create_tiktok_client_failed';
  constructor() {
    super();
  }
}
export class LinkableListListAccountsFailedError extends Error {
  public readonly name = 'LinkableListListAccountsFailedError';
  public readonly message = 'message.tiktok_linkable_list-list_accounts_failed';
  constructor() {
    super();
  }
}
export class LinkableListListAccountDetailsFailedError extends Error {
  public readonly name = 'LinkableListListAccountDetailsFailedError';
  public readonly message = 'message.tiktok_linkable_list-list_account_details_failed';
  constructor() {
    super();
  }
}
export class UploadedCreativesInvalidParamsError extends Error {
  public readonly name = 'UploadedCreativesInvalidParamsError';
  public readonly message = 'message.tiktok_uploaded_creatives-invalid_params';
  constructor() {
    super();
  }
}
export class UploadCreativeInvalidParamsError extends Error {
  public readonly name = 'UploadCreativeInvalidParamsError';
  public readonly message = 'message.tiktok_upload_creative-invalid_params';
  constructor() {
    super();
  }
}
export class UploadCreativeTokenNotFoundError extends Error {
  public readonly name = 'UploadCreativeTokenNotFoundError';
  public readonly message = 'message.tiktok_upload_creative-token_not_found';
  constructor() {
    super();
  }
}
export class UploadCreativeCreateTiktokClientFailedError extends Error {
  public readonly name = 'UploadCreativeCreateTiktokClientFailedError';
  public readonly message = 'message.tiktok_upload_creative-create_tiktok_client_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeCreateTmpFileFailedError extends Error {
  public readonly name = 'UploadCreativeCreateTmpFileFailedError';
  public readonly message = 'message.tiktok_upload_creative-create_tmp_file_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeDownloadingCreativeFailedError extends Error {
  public readonly name = 'UploadCreativeDownloadingCreativeFailedError';
  public readonly message = 'message.tiktok_upload_creative-downloading_creative_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeCopyDownloadCreativeFailedError extends Error {
  public readonly name = 'UploadCreativeCopyDownloadCreativeFailedError';
  public readonly message = 'message.tiktok_upload_creative-copy_download_creative_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeRegisterDataFailedError extends Error {
  public readonly name = 'UploadCreativeRegisterDataFailedError';
  public readonly message = 'message.tiktok_upload_creative-register_data_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeUploadFileFailedError extends Error {
  public readonly name = 'UploadCreativeUploadFileFailedError';
  public readonly message = 'message.tiktok_upload_creative-upload_file_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeUploadVideoFailedError extends Error {
  public readonly name = 'UploadCreativeUploadVideoFailedError';
  public readonly message = 'message.tiktok_upload_creative-upload_video_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeGetVideoInfoFailedError extends Error {
  public readonly name = 'UploadCreativeGetVideoInfoFailedError';
  public readonly message = 'message.tiktok_upload_creative-get_video_info_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeNoPermissionError extends Error {
  public readonly name = 'UploadCreativeNoPermissionError';
  public readonly message = 'message.tiktok_upload_creative-no_permission';
  constructor() {
    super();
  }
}
export class LinkAccountsInvalidParamsError extends Error {
  public readonly name = 'LinkAccountsInvalidParamsError';
  public readonly message = 'message.tiktok_link_accounts-invalid_params';
  constructor() {
    super();
  }
}
export class LinkAccountsDuplicateError extends Error {
  public readonly name = 'LinkAccountsDuplicateError';
  public readonly message = 'message.tiktok_link_accounts-duplicate';
  constructor() {
    super();
  }
}
export class LinkAccountsRegisterTokenAdaccountFailedError extends Error {
  public readonly name = 'LinkAccountsRegisterTokenAdaccountFailedError';
  public readonly message = 'message.tiktok_link_accounts-register_token_adaccount_failed';
  constructor() {
    super();
  }
}
export class LinkAccountsTokenNotFoundError extends Error {
  public readonly name = 'LinkAccountsTokenNotFoundError';
  public readonly message = 'message.tiktok_link_accounts-token_not_found';
  constructor() {
    super();
  }
}
export class LinkAccountsCreateTiktokClientFailedError extends Error {
  public readonly name = 'LinkAccountsCreateTiktokClientFailedError';
  public readonly message = 'message.tiktok_link_accounts-create_tiktok_client_failed';
  constructor() {
    super();
  }
}
export class LinkAccountsGetAccountApiFailedError extends Error {
  public readonly name = 'LinkAccountsGetAccountApiFailedError';
  public readonly message = 'message.tiktok_link_accounts-get_account_api_failed';
  constructor() {
    super();
  }
}
export class LinkAccountsRegisterAdaccountFailedError extends Error {
  public readonly name = 'LinkAccountsRegisterAdaccountFailedError';
  public readonly message = 'message.tiktok_link_accounts-register_adaccount_failed';
  constructor() {
    super();
  }
}
export class UnlinkAccountsInvalidParamsError extends Error {
  public readonly name = 'UnlinkAccountsInvalidParamsError';
  public readonly message = 'message.tiktok_unlink_accounts-invalid_params';
  constructor() {
    super();
  }
}
export class UnlinkAccountsAdaccountNotFoundError extends Error {
  public readonly name = 'UnlinkAccountsAdaccountNotFoundError';
  public readonly message = 'message.tiktok_unlink_accounts-adaccount_not_found';
  constructor() {
    super();
  }
}
export class UnlinkAccountsDeleteAdaccountFailedError extends Error {
  public readonly name = 'UnlinkAccountsDeleteAdaccountFailedError';
  public readonly message = 'message.tiktok_unlink_accounts-delete_adaccount_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeValidationErrorDuplicate extends Error {
  public readonly name = 'UploadCreativeValidationErrorDuplicate';
  public readonly message = 'message.tiktok_upload_creative-validation_error_duplicate';
  constructor() {
    super();
  }
}
export class UploadCreativeValidationErrorMaxFileSize extends Error {
  public readonly name = 'UploadCreativeValidationErrorMaxFileSize';
  public readonly message = 'message.tiktok_upload_creative-validation_error_max_file_size';
  constructor() {
    super();
  }
}

class TiktokAdWebApi {
  private readonly graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  /**
   * @param organizationId
   * 連携済みTiktokAdAccountの配列が返却されます
   */
  public getAllIntegratedAdAccounts = async (organizationId: string): Promise<ReadonlyArray<TiktokAdAccount>> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query integratedTiktokAdAccounts($organizationId: ID!) {
            integratedTiktokAdAccounts(organizationId: $organizationId) {
              id
              adAccountId
              name
            }
          }
        `,
        { organizationId },
      );
      return result.integratedTiktokAdAccounts as TiktokAdAccount[];
    } catch (err) {
      handleTiktokAdError(err);
      throw err;
    }
  };

  /**
   * @param organizationId
   * @param tokenId
   * TiktokAdAccountのtokenIdを渡し、連携可能なアカウント一覧を返します
   */
  public getAllAccessibleTiktokAdAccounts = async (
    organizationId: string,
    tokenId: string,
  ): Promise<ReadonlyArray<TiktokAdAccount>> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query accessibleTiktokAdAccounts($organizationId: ID!, $tokenId: ID!) {
            accessibleTiktokAdAccounts(organizationId: $organizationId, tokenId: $tokenId) {
              id
              adAccountId
              name
            }
          }
        `,
        { organizationId, tokenId },
      );
      return result.accessibleTiktokAdAccounts as TiktokAdAccount[];
    } catch (err) {
      handleTiktokAdError(err);
      throw err;
    }
  };

  /**
   * @param authCode
   * 連携するtiktokAdAccountのauthCodeを渡し、tokenIdを受け取ります
   */
  public registerTiktokAccount = async (authCode: string, organizationId: string): Promise<string> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation registerTiktokToken($authCode: String!, $organizationId: ID!) {
            registerTiktokToken(authCode: $authCode, organizationId: $organizationId)
          }
        `,
        { authCode, organizationId },
      );
      const item = result.registerTiktokToken as string;
      return item;
    } catch (err) {
      handleTiktokAdError(err);
      throw err;
    }
  };

  /**
   * @param organizationId
   * @param tiktokAdAccountId
   * @param tokenId
   * TiktokAdAccount連携に必要なパラメータを渡し、連携を行います
   * 連携成功の場合true, 失敗の場合false
   */
  public integrateAdAccount = async (
    organizationId: string,
    tiktokAdAccountId: string,
    tokenId: string,
  ): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation integrateTiktokAdAccount($organizationId: ID!, $tiktokAdAccountId: ID!, $tokenId: ID!) {
            integrateTiktokAdAccount(
              organizationId: $organizationId
              tiktokAdAccountId: $tiktokAdAccountId
              tokenId: $tokenId
            )
          }
        `,
        { organizationId, tiktokAdAccountId, tokenId },
      );
      return result.integrateTiktokAdAccount as boolean;
    } catch (err) {
      handleTiktokAdError(err);
      throw err;
    }
  };

  /**
   * @param organizationId
   * @param tiktokAdAccountId
   * tiktokAdAccountの連携を解除します
   */
  public unlinkTiktokAdAccount = async (organizationId: string, tiktokAdAccountId: string): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation unlinkTiktokAdAccount($organizationId: ID!, $tiktokAdAccountId: ID!) {
            unlinkTiktokAdAccount(organizationId: $organizationId, tiktokAdAccountId: $tiktokAdAccountId)
          }
        `,
        { organizationId, tiktokAdAccountId },
      );
      return result.unlinkTiktokAdAccount as boolean;
    } catch (err) {
      handleTiktokAdError(err);
      throw err;
    }
  };

  /**
   * @param creativeId
   * @param organizationId
   * @param projectId
   * TiktokAdAccountに対して、クリエイティブ連携を行います
   */
  public sendCreativeToTiktok = async (
    creativeId: string,
    organizationId: string,
    projectId: string,
    tiktokAdAccountId: string,
  ): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation sendCreativeToTiktok(
            $creativeId: ID!
            $organizationId: ID!
            $projectId: ID!
            $tiktokAdAccountId: ID!
          ) {
            sendCreativeToTiktok(
              creativeId: $creativeId
              organizationId: $organizationId
              projectId: $projectId
              tiktokAdAccountId: $tiktokAdAccountId
            ) {
              id
            }
          }
        `,
        { creativeId, organizationId, projectId, tiktokAdAccountId },
      );
      return result.sendCreativeToTiktok as boolean;
    } catch (err) {
      handleTiktokAdError(err);
      throw err;
    }
  };

  /**
   * @param organizationId
   * @param creativeIds
   * TiktokAdAccountに紐づいているクリエイティブを返します
   */
  public getUploadedTiktokCreatives = async (
    organizationId: string,
    creativeIds: string[],
  ): Promise<TiktokUploadedCreative[]> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query uploadedTiktokCreatives($organizationId: ID!, $creativeIds: [ID!]!) {
            uploadedTiktokCreatives(organizationId: $organizationId, creativeIds: $creativeIds) {
              creativeId
              mediaId
              uploadedAt
            }
          }
        `,
        { organizationId, creativeIds },
      );
      return result.uploadedTiktokCreatives;
    } catch (err) {
      handleTiktokAdError(err);
      throw err;
    }
  };
}

export default TiktokAdWebApi;
